import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription, Observable } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';

import { APP_SETTINGS } from '@services';
import { NgIf, NgFor, NgClass, NgStyle, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-videos-watchlist',
    templateUrl: './videos-watchlist.component.html',
    styleUrls: ['./videos-watchlist.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink, NgFor, NgClass, NgStyle, DatePipe, HighlightSearchPipe]
})
export class VideosWatchlistComponent implements OnInit, OnDestroy {

  public screenWidth: any;
  public videoList: any;
  private subscription: ISubscription[];
  private isSaved = true;
  username: string;
  public dateFormat: string;
  
  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  APP_SETTINGS: any;
  constructor(
    private videoService: VideosService,
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService,
    private dialogService: DialogService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private toastService: ToastConfigService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.subscription = [];
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.videoService.getUsersWatchlist(this.username).subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.videoList = value;
    }));
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (!this.isSaved) {
      if (this.dialogService.confirm('Discard changes?')['value'] === true) {
        this.applyChanges();
        return true;
      }
      return false;
    }
    return true;
  }
  moveItemUp(index, video) {
    if (index > 0) {
      this.isSaved = false;
      this.videoList.splice(index, 1);
      this.videoList.splice(index - 1, 0, video);
    }
  }
  moveItemDown(index, video) {
    if (index < this.videoList.length - 1) {
      this.isSaved = false;
      this.videoList.splice(index, 1);
      this.videoList.splice(index + 1, 0, video);
    }
  }
  moveItemTop(index, video) {
    if (index > 0) {
      this.isSaved = false;
      this.videoList.splice(index, 1);
      this.videoList.splice(0, 0, video);
    }
  }
  moveItemBottom(index, video) {
    if (index < this.videoList.length - 1) {
      this.isSaved = false;
      this.videoList.splice(index, 1);
      this.videoList.splice(this.videoList.length, 0, video);
    }
  }
  transferDataSuccess(data) {
    this.isSaved = false;
  }
  applyChanges() {
    if (!this.isSaved) {
      this.isSaved = true;
      for (let i = 0; i < this.videoList.length; i++) {
        this.videoList[i]['sortingOrder'] = i + 1;
      }
      this.subscription.push(this.videoService.saveWatchlistSortOrder(this.username, this.videoList).subscribe(value => {
      }));
    }
  }
  removeFromWatchlist(videoId) {
    this.subscription.push(this.videoService.removeVideoFromWatchlist(this.username, videoId).subscribe(value => {
      this.videoList = value;
    }));
  }

  showSuccess() {
    this.toastService.popToast('Successful message');
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}
